import { FormProvider } from '@slal/ui/react-hook-form/core';
import { Field, FieldSet, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { Article, Heading, P, Text } from '@slal/ui/typography';
import { MaxWidthContent, Notification, StyledForm, yesOrNoOptions } from '~/components';
import { ApplicationButtons } from '~/features';
import { useKeyConsiderationsApplicationForm } from './hooks';
import { SelectedYesNoContent } from './SelectedYesNoContent';

const YesContent = () => {
    return (
        <Article>
            <Heading level={5}>
                We recommend you pause here and think carefully if you have serious health issues before you go any
                further.
            </Heading>
            <P>
                When you have a serious health condition it can affect your options when it comes to your pension,
                particularly if your life expectancy is less than a year.
            </P>
            <P markdown>
                You can find out more about ill health and pensions from [Pension
                Wise](https://www.moneyhelper.org.uk/en/pensions-and-retirement/taking-your-pension/early-retirement-because-of-illness-sickness-or-disability?source=pw#),
                a service from MoneyHelper.
            </P>
            <Notification level="warning">
                <P>
                    You may be able to get your full pension pot paid as one lump sum free from income tax in some
                    circumstances.
                </P>
                <P>
                    <Text tag="strong">Please call ReAssure on 0800 073 1777 to discuss.</Text>. Call charges will vary.
                </P>
            </Notification>
        </Article>
    );
};

const NoContent = () => {
    return (
        <Article>
            <Heading level={5}>That's good news.</Heading>
            <P markdown>
                This online process isn't appropriate for people in serious ill health, particularly if their life
                expectancy is less than a year. They may have different pension options, including being able to take
                their pension early as a lump sum. They may not need to pay income tax on it in some circumstances,
                although inheritance tax could potentially be due on anything unspent. You can find out more about ill
                health and pensions from [Pension
                Wise](https://www.moneyhelper.org.uk/en/pensions-and-retirement/taking-your-pension/early-retirement-because-of-illness-sickness-or-disability?source=pw#),
                a service from MoneyHelper.
            </P>
        </Article>
    );
};

export const HealthIssuesForm = () => {
    const { form, handleSubmit, name, option } = useKeyConsiderationsApplicationForm(
        'healthIssues',
        '/application/key-considerations/investment-scams'
    );

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit}>
                    <FieldSet aria-label="Health issues">
                        <Field errorFor={name}>
                            <RadioFieldGroup name={name} options={yesOrNoOptions} stacked />
                        </Field>
                    </FieldSet>
                    {option && (
                        <SelectedYesNoContent option={option} YesContent={<YesContent />} NoContent={<NoContent />} />
                    )}
                    <ApplicationButtons backTo="/application/key-considerations/main-plan" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
